import React, { useEffect, useState } from "react"
import { View, Text, StyleSheet, TouchableOpacity, Platform } from "react-native";
import { DrawerActions } from '@react-navigation/native';
import * as FileSystem from "expo-file-system";
import { COLORS, ROUTES } from "../constants";
import BurguerIcon from '../assets/images/burguer.svg';
import FavoriteOffIcon from '../assets/images/favorite-off.svg';
import FavoriteIcon from '../assets/images/favorite.svg';
import DownloadIcon from '../assets/images/download.svg';
import DownloadDoneIcon from '../assets/images/download-done.svg';
import SearchIcon from '../assets/images/search.svg';
import { NavigationProps } from "../screens/Home";
import { Icon } from "../lib/Icon";
import { useGlobalContext } from "../context/GlobalContext";
import { HymnProps } from "../types";
import { openDatabase } from "../database/database";
import { getNameAudio, getUriAudio } from './Player';
import ProgressPie from "./animation/ProgressPie";

function HeaderSearch (props: NavigationProps) {
  const {
    hymnId,
    hymns,
    setHymns,
    setFavorites,
    favorites,
    startDownload,
    setStartDownload
  } = useGlobalContext();

  const [isFavorite, setIsFavorite] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [progressDownload, setProgressDownload] = useState<number>(0);

  const handleFavorite = async () => {
    const favorite = favorites.find(element => element.id === hymnId);
    let items: HymnProps[] = []
    if (favorite) {
      items = favorites.filter(item => item.id !== hymnId);
      if (Platform.OS !== 'web') {
        const db = await openDatabase();
        db.transaction((tx) => {
          tx.executeSql(
            'DELETE from favorites WHERE hymn_id=?;',
            [hymnId]
          );
        });
      }
    } else {
      const newHymn = hymns.find(element => element.id === hymnId);
      if (newHymn) {
        items = [...favorites, newHymn];
        if (Platform.OS !== 'web') {
          const db = await openDatabase();
          db.transaction((tx) => {
            tx.executeSql(
              'INSERT OR IGNORE INTO favorites(hymn_id) VALUES(?);',
              [hymnId]
            );
          });
        }
      }
    }
    if (Platform.OS === 'web') {
      window.localStorage.setItem('favorites', JSON.stringify(items));
    }
    setFavorites(items);
  }

  const downloadProgressCallback = (downloadProgress: FileSystem.DownloadProgressData) => {
    const progress = downloadProgress.totalBytesWritten / downloadProgress.totalBytesExpectedToWrite;
    setProgressDownload(progress);
  };

  const handleDownload = async () => {
    const fileUri: string = `${FileSystem.documentDirectory}${getNameAudio(hymnId)}`;
    const uri: string = getUriAudio(hymnId);

    try {
      const fileInfo = await FileSystem.getInfoAsync(fileUri);

      if (!fileInfo?.exists) {
        const db = await openDatabase();
        setProgressDownload(0);
        setStartDownload(true);
        const downloadResumable = FileSystem.createDownloadResumable(
          uri,
          fileUri,
          {},
          downloadProgressCallback
        );
        await downloadResumable.downloadAsync();
        setStartDownload(false);
        setIsDownload(true);
        db.transaction((tx) => {
          tx.executeSql(
            'UPDATE hymns SET download = 1 WHERE id = ?;',
            [hymnId]
          );
        });
        setHymns(hymns.map(item => {
          if (item.id === hymnId) {
            item.download = 1;
          }
          return item;
        }))
        console.log('DOWNLOAD', fileUri);
      } else {
        console.log('YA EXISTE');
      }
    } catch (error) {
      console.log(`ERROR: ${error}`);
    }
  }

  useEffect(() => {
    setIsFavorite(!!favorites.find(element => element.id === hymnId));
    (async () => {
      if (Platform.OS !== 'web') {
        const fileUri: string = `${FileSystem.documentDirectory}${getNameAudio(hymnId)}`;
        const fileInfo = await FileSystem.getInfoAsync(fileUri);
        setIsDownload(fileInfo?.exists);
      }
    })();
  }, [favorites, hymnId, startDownload]);
  
  return (
    <View style={styles.container}>
      <View style={{ width: 52 }}>
        <TouchableOpacity
          style={styles.buttonLeft}
          onPress={() => props.navigation?.dispatch(DrawerActions.openDrawer())}>
          <Icon><BurguerIcon /></Icon>
        </TouchableOpacity>
      </View>
      <View style={{ flex: 1 }}>
        <TouchableOpacity
          style={styles.inputSearch}
          onPress={() => props.navigation?.navigate(ROUTES.SEARCH_DRAWER)}>
          <Text style={styles.inputSearchText}>Buscar himno...</Text>
          <Icon><SearchIcon style={styles.inputSearchIcon} /></Icon>
        </TouchableOpacity>
      </View>
      {Platform.OS !== 'web' && <View style={[styles.containerButton, { marginLeft: 6 }]}>
        {startDownload
          ? <ProgressPie progress={progressDownload} />
          : <TouchableOpacity
            style={[styles.buttonRight, { marginTop: isDownload ? 0 : 3 }]}
            onPress={handleDownload}
            disabled={isDownload}>
            <Icon>{isDownload ? <DownloadDoneIcon /> : <DownloadIcon />}</Icon>
        </TouchableOpacity>}
      </View>}
      <View style={[styles.containerButton, Platform.OS === 'web' ? { marginHorizontal: 6 } : { marginRight: 6 }]}>
        <TouchableOpacity
          style={styles.buttonRight}
          onPress={handleFavorite}>
          { isFavorite ? <Icon><FavoriteIcon /></Icon> : <Icon><FavoriteOffIcon /></Icon>}
        </TouchableOpacity>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: COLORS.primary,
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 54
  },
  containerButton: {
    width: 42,
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonLeft: {
    padding: 10,
    marginTop: 8,
    marginHorizontal: 5,
    borderRadius: 50,
    height: 42,
  },
  buttonRight: {
    width: 40,
    borderRadius: 50,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center'
  },
  inputSearch: {
    backgroundColor: COLORS.white,
    height: 38,
    borderRadius: 20,
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginTop: 7,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  inputSearchText: {
    color: COLORS.textLight,
    fontFamily: 'Poppins',
    fontSize: 16
  },
  inputSearchIcon: {
    marginTop: 3,
  }
});

export default HeaderSearch;
